import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=69be534d&scoped=true&"
var script = {}
import style0 from "./Projects.vue?vue&type=style&index=0&id=69be534d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69be534d",
  null
  
)

export default component.exports